import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Voice } from 'src/app/models/call/voice';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';
import { UsersService } from '../users.service';

@Injectable({
    providedIn: 'root',
})
export class VoiceService extends ServiceBase {
    private http = inject(HttpClient);
    private usersService = inject(UsersService);
    private organizationsServices = inject(OrganizationsService);

    constructor() {
        super();
    }

    getCalls(): Observable<Voice[]> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? '')
                .set('X-UserId', this.usersService.getSessionCurrentUser().id ?? ''),
        };

        let url = `${this.baseUrl}/api/calls?`;

        return this.http.get<Voice[]>(url, httpOptions);
    }

    releaseCall(callId: string) {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? '')
                .set('X-UserId', this.usersService.getSessionCurrentUser().id ?? ''),
        };

        let url = `${this.baseUrl}/api/calls/${callId}`;

        return this.http.delete<Voice>(url, httpOptions);
    }
}
